import { useQuery } from "hooks/useQuery";
import { getStrategyOverview } from "../service";

export const useStrategyOverview = () => {
  const { isLoading, data, error, refetch } = useQuery({
    key: "strategyOverview",
    queryKey: ["strategyOverview"],
    queryFn: () => getStrategyOverview(),
  });

  return { isLoading, data, error, refetch };
};
